Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "AvatarGroup1512389470",
  {"root":"AvatarGroup1512389470--root","avatars":"AvatarGroup1512389470--avatars","avatarContainer":"AvatarGroup1512389470--avatarContainer","avatar":"AvatarGroup1512389470--avatar","textButtonContainer":"AvatarGroup1512389470--textButtonContainer","textButton":"AvatarGroup1512389470--textButton","DefaultAvatarBorderColor":"color-1","AvatarBorderColor":"--overridable","TextButtonFont":"--overridable","TextButtonColor":"--overridable","avatarBorderColorValue":"\"fallback(--overridable, color-1)\"","SmallerTextButtonFont":"\"{theme: 'Body-M', size: '14px', lineHeight: '1.44em'}\""},
  "",
  8,
  "AvatarGroup1512389470"
);

